(function () {
const __pewniaki_inline_cfg = JSON.parse(document.currentScript.previousElementSibling.textContent);
window.PEWNIAKI_ANALIZA = {
    plik:   '/assets/json/db/' + __pewniaki_inline_cfg[0] + '/analizy/struktura.json',
    wersja: __pewniaki_inline_cfg[1],
    lata:   '/assets/json/db/' + __pewniaki_inline_cfg[2] + '/lata/',
    // Fallback, gdyby struktura.json na serwerze byl jeszcze bez naglowka pula/typuje.
    pula:   JSON.parse(String(__pewniaki_inline_cfg[3])),
    typuje: JSON.parse(String(__pewniaki_inline_cfg[4])),
    // Zakres lat: suma SUROWYCH licznikow koncowek z rocznikow (plan V2 §5.3).
    sumujLata: function (roczniki) {
        var kon = {}, N = 0, liczby = {};
        roczniki.forEach(function (r) {
            N += r.losowan || 0;
            Object.keys(r.main || {}).forEach(function(n){liczby[n]={hits:(liczby[n]?liczby[n].hits:0)+Number(r.main[n]||0)};});
            Object.keys(r.koncowki || {}).forEach(function (c) { kon[c] = (kon[c] || 0) + r.koncowki[c]; });
        });
        return { losowan: N, koncowki: kon, liczby: liczby };
    },
    T13: {
        brakD:  __pewniaki_inline_cfg[5],
        brakZ:  __pewniaki_inline_cfg[6],
        lider:  __pewniaki_inline_cfg[7],
        histor: __pewniaki_inline_cfg[8],
        roznica:__pewniaki_inline_cfg[9],
        naj:    __pewniaki_inline_cfg[10],
        rzad:   __pewniaki_inline_cfg[11]
    },
    wnioski: function (o) {
        var T = window.PEWNIAKI_ANALIZA.T13;
        if (!o) return [T.brakD];
        var h = o.koncowki || {}, keys = Object.keys(h).sort(function(a,b) { return h[b]-h[a] || String(a).localeCompare(String(b)); });
        if (!keys.length || !o.losowan) return [T.brakZ];
        return [T.lider.replace('%1', keys[0]).replace('%2', h[keys[0]]).replace('%3', o.losowan), T.histor];
    },
    render: function (okno, klucz, dane) {
        var api = window.PEWNIAKI_ANALIZA;
        var q = function (s) { return document.querySelector(s); };
        var tys = function (v) { return String(v).replace(/\B(?=(\d{3})+(?!\d))/g, ' '); };
        var f1 = function (v) { return v == null ? '—' : tys((Math.round(v * 10) / 10).toFixed(1)).replace('.', /^en(?:-|$)/i.test(document.documentElement.lang || '') ? '.' : ','); };
        var znak = function (v) { return (v >= 0 ? '+' : '−') + f1(Math.abs(v)); };
        var sekcja = q('[data-koncowki]');
        if (!okno) { if (sekcja) { sekcja.hidden = true; } return; }
        if (sekcja) { sekcja.hidden = false; }
        var pula = dane.pula || api.pula, typuje = dane.typuje || api.typuje;
        var N = okno.losowan || 0, kon = okno.koncowki || {};
        // liczb w puli z dana koncowka — ta sama petla co w Twigu
        var wPuli = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
        for (var n = 1; n <= pula; n++) { wPuli[n % 10]++; }
        var razem = 0, c;
        for (c = 0; c <= 9; c++) { razem += kon[c] || 0; }
        var kolej = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9].sort(function (a, b) { return (kon[b] || 0) - (kon[a] || 0) || a - b; });
        var naj = kolej[0], rzad = kolej[9];
        var ocz = function (e) { return pula ? N * typuje * wPuli[e] / pula : 0; };
        q('[data-koncowki-n]').textContent = tys(N);
        q('[data-koncowki-razem]').textContent = tys(razem);
        q('[data-koncowki-naj]').textContent = naj;
        q('[data-koncowki-naj-ile]').textContent = tys(kon[naj] || 0);
        q('[data-koncowki-naj-ocz]').textContent = f1(ocz(naj));
        q('[data-koncowki-rzad]').textContent = rzad;
        q('[data-koncowki-rzad-ile]').textContent = tys(kon[rzad] || 0);
        q('[data-koncowki-rzad-ocz]').textContent = f1(ocz(rzad));
        var wiersze = [];
        for (c = 0; c <= 9; c++) {
            var traf = kon[c] || 0, o = ocz(c);
            wiersze.push('<tr><td class="liczbowa">' + c + '</td><td class="liczbowa">' + tys(traf) + '</td><td class="liczbowa">'
                + (razem ? f1(traf * 100 / razem) : '—') + '%</td><td class="liczbowa">' + f1(o) + '</td><td class="liczbowa">' + znak(traf - o) + '</td><td>' + Array.from({length:pula},function(_,i){return i+1;}).filter(function(n){return n%10===c;}).map(function(n){var count=okno.liczby && okno.liczby[n] || __pewniaki_inline_cfg[12] && __pewniaki_inline_cfg[12][klucz] && __pewniaki_inline_cfg[12][klucz].liczby[n];return n+(count?' ('+count.hits+')':'');}).join(', ') + '</td></tr>');
        }
        q('[data-koncowki-tabela] tbody').innerHTML = wiersze.join('');
        var T = api.T13;
        q('[data-koncowki-zdanie]').textContent = razem
            ? T.roznica.replace('%1', naj).replace('%2', tys(kon[naj] || 0)).replace('%3', rzad).replace('%4', tys(kon[rzad] || 0))
                .replace('%5', tys((kon[naj] || 0) - (kon[rzad] || 0))).replace('%6', tys(razem)).replace('%7', tys(N))
            : '';
        // zdania „Co wynika z tych liczb" — dwa punkty w tej samej kolejnosci co w Twigu
        var zdania = document.querySelectorAll('.wniosek .wniosek__zdanie');
        var opis = function (e, wzor) {
            return wzor.replace('%1', e).replace('%2', tys(kon[e] || 0)).replace('%3', tys(N)).replace('%4', f1(ocz(e))).replace('%5', wPuli[e]);
        };
        if (zdania[0]) { zdania[0].textContent = opis(naj, T.naj); }
        if (zdania[1]) { zdania[1].textContent = opis(rzad, T.rzad); }
    }
};
})();
